import { Pipe, PipeTransform } from '@angular/core';
import * as linkify from 'linkifyjs';

@Pipe({
  name: 'links',
})
export class LinksPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value;
    const urls = linkify.find(value);

    if (!urls.length) {
      return this.escapeHtml(value);
    }

    let result = '';
    let cursor = 0;

    urls.forEach((url) => {
      if (typeof url.start !== 'number' || typeof url.end !== 'number') {
        return;
      }

      result += this.escapeHtml(value.slice(cursor, url.start));

      const linkText = this.escapeHtml(value.slice(url.start, url.end));
      const href = this.escapeAttribute(url.href);
      result += `<a target="_blank" rel="noopener noreferrer" href="${href}">${linkText}</a>`;

      cursor = url.end;
    });

    result += this.escapeHtml(value.slice(cursor));

    return result;
  }

  private escapeHtml(input: string): string {
    return input
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  private escapeAttribute(input: string): string {
    return input
      .replace(/&/g, '&amp;')
      .replace(/\"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
}
